import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const propTypes = {
  title: PropTypes.string.isRequired,
  titleId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  open: PropTypes.bool,
  color: PropTypes.string,
};

export const TransitionDuration = '300ms';
export const TransitionTimingFunction = 'ease-in';

const BurgerMenu = ({ title, titleId, onClick, open, ...rest }) => (
  <MenuButton
    aria-expanded={open}
    onClick={onClick}
    aria-label={title}
    aria-labelledby={titleId}
  >
    <Svg role="img" aria-hidden={true} focusable={false} {...rest}>
      <g>
        <path d={open ? 'M3,4 L15,14' : 'M2,3 L16,3'} />
        <path opacity={open ? 0 : 1} d={open ? 'M3,4 L15,14' : 'M2,9 L16,9'} />
        <path d={open ? 'M15,4 L3,14' : 'M2,15 L16,15'} />
      </g>
    </Svg>
  </MenuButton>
);

const MenuButton = styled.button`
  background: none;
  border: none;
`;

const Svg = styled.svg.attrs({
  viewBox: '0 0 18 18',
  role: 'img',
})`
  path {
    stroke: ${({ color = 'currentColor' }) => color};
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-linejoin: round;

    transition-property: d, opacity;
    transition-duration: ${TransitionDuration};
    transition-timing-function: ${TransitionTimingFunction};
  }
`;

BurgerMenu.propTypes = propTypes;

export default BurgerMenu;
